"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUserCookies = void 0;

var _isVIP = require("./isVIP");

var _isSubscribed = require("./isSubscribed");

var _isAuthenticated = require("./isAuthenticated");

var getUserCookies = function getUserCookies() {
  return {
    isAuthenticated: (0, _isAuthenticated.getIsAuthenticatedCookie)(),
    isSubscribed: (0, _isSubscribed.getIsSubscribedCookie)(),
    isVIP: (0, _isVIP.getIsVIPCookie)()
  };
};

exports.getUserCookies = getUserCookies;